import { useEffect } from 'react';
const useScrollLock = (lock = true) => useEffect(() => {
    if (lock) {
        document.body.style.overflow = 'hidden';
    }
    else {
        document.body.style.overflow = 'auto';
    }
    return () => {
        document.body.style.overflow = 'auto';
    };
});
export default useScrollLock;
//# sourceMappingURL=index.js.map